import { FALLBACKIMAGES } from "@/common/commonConstants"
import { Box, Flex, Heading, Image, useColorMode } from "@chakra-ui/react"
import { useNavigate } from "react-router"
import { chakraTheme } from "../../theme/chakraTheme"

const IMAGE_SIZES = ["129px", "130px", "242px"]
const PADDING_SIZES = [0, 1, 1]

interface ProductProps {
  imagePath?: string
  name: string
  gridUnit: string
  redirectURL: string
  isLoading?: boolean
  onImageError?: () => void
}

export const ProductThumbnail = ({ imagePath, name, gridUnit, redirectURL, isLoading = false, onImageError }: ProductProps): JSX.Element => {
  const { colorMode } = useColorMode()
  const cardBg = colorMode === "light" ? chakraTheme.colors.cardBgLight : chakraTheme.colors.cardBgDark
  const navigate = useNavigate()
  const navigateTo = (link: string): void => {
    navigate(link)
  }
  const fallBackImage = FALLBACKIMAGES["150x150"]

  return (
    <Flex
      role="button"
      aria-label={`View ${name} product details`}
      boxShadow={"0px 6px 20px 0px rgba(0, 0, 0, 0.1)"}
      borderRadius={"10px"}
      bg={cardBg}
      width={gridUnit}
      flexDir={"column"}
      justify={"space-between"}
      onClick={() => {
        navigateTo(redirectURL)
      }}
      p={PADDING_SIZES}
      cursor={"pointer"}
      opacity={isLoading ? 0.7 : 1}
      transition="opacity 0.2s"
    >
      <Box
        w={IMAGE_SIZES}
        height={IMAGE_SIZES}
        backgroundColor={imagePath ? "white" : chakraTheme.colors.imageFallBackBackground}
        m="2"
        mb={[0, 0, 2]}
        mx="auto"
        position="relative"
        borderRadius={"8px"}
      >
        {imagePath ? (
          <Image
            src={imagePath}
            alt={`Product image for ${name}`}
            loading="lazy"
            objectFit="contain"
            width="100%"
            height="100%"
            onError={onImageError}
            borderRadius={"8px"}
            border={`1px solid ${chakraTheme.colors.grayE}`}
          />
        ) : (
          <Image borderRadius={"8px"} src={fallBackImage} alt="Product placeholder" height="100%" width="100%" objectFit="contain" />
        )}
      </Box>

      <Heading
        mb={["8px", "8px", "12px"]}
        pt="0px"
        pos={"relative"}
        top={["6px", "6px", "4px"]}
        variant="Heading3Work"
        px="3"
        color="primary"
        textAlign={"center"}
      >
        {name}
      </Heading>
    </Flex>
  )
}
